import styled from 'styled-components/macro';

import {useActions, useLoggedIn, useSettings} from "../store";
import Post from "./post";
import {useAdConfig} from "../api/ads";
import AdUnit from "./feed-inserts/ad";
import {useEffect, useRef, useState} from "react";
import {debounce} from "lodash";
import {useBaseCommunity} from "../store/hooks";
import {themecolors} from "../utils/themecolors";

function PostList({className, feedKey, initialExpand, posts, show_community, loading, hideBlocked, sort, inFeed, showAds, jumpToPos, setHasRestored}) {
    const {blocked} = useSettings();
    const adConfig = useAdConfig();
    const [jumpTo, setJumpTo] = useState(jumpToPos);
    const jumpRef = useRef();
    const [restoredPos, setRestoredPos] = useState(false);
    const actions = useActions();
    useEffect(() => {

        actions.lastFeedPosChanged(feedKey, 0);

        setJumpTo(jumpToPos);

        // if feed key changes, set allow restoring feed pos again
        setRestoredPos(false);

    }, [feedKey]);
    useEffect(() => {

        if (posts?.length > 0 && !restoredPos && setHasRestored !== undefined) {
            setHasRestored(true);
        }
        if (posts?.length > 0 && !restoredPos && jumpTo && jumpTo > 0 && jumpRef && jumpRef.current) {
            const timeoutId = setTimeout(() => {
                jumpRef.current.scrollIntoView({ behavior: 'auto', block: 'start' })
                setRestoredPos(true);
            }, 0);
        }

    }, [posts]);

    const containerRef = useRef(null);
    const [visibleItemIndex, setVisibleItemIndex] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (containerRef.current) {
                const container = containerRef.current;
                const items = container.querySelectorAll(".post-item");

                let highestVisibleIndex = 0;
                let highestVisibleTop = Infinity;

                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    const rect = item.getBoundingClientRect();
                    const isVisible =
                        rect.top >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

                    if (isVisible && rect.top < highestVisibleTop) {
                        highestVisibleIndex = i;
                        highestVisibleTop = rect.top;
                    }
                }

                setVisibleItemIndex(highestVisibleIndex);
            }
        };

        const debouncedHandleScroll = debounce(handleScroll, 200);

        window.addEventListener("scroll", debouncedHandleScroll);

        return () => window.removeEventListener("scroll", debouncedHandleScroll);
    }, []);

    useEffect(() => {
            // change the id
            actions.lastFeedPosChanged(feedKey, visibleItemIndex);
    }, [visibleItemIndex]);

    const baseCommunity = useBaseCommunity();

    return (
        <div className={className} ref={containerRef}>
            {posts?.map((post, index) => {
                const props = index === jumpTo ? {ref: jumpRef} : {};
                return (
                <div className={"post-item"} key={post.id} id={post.id} data-index={index} {...props}>
                    {inFeed && inFeed[index]}
                    {baseCommunity !== "TheDonald" && showAds && adConfig && adConfig.v2 && <Possible1pAd index={index} adConfig={adConfig} feedKey={feedKey}/>}
                    {baseCommunity === "TheDonald" && showAds && adConfig && adConfig.v2 && <Possible3pAd index={index} adConfig={adConfig} feedKey={feedKey}/>}
                    {(!hideBlocked || !blocked?.includes(post?.author)) &&
                    <div>
                        <Post
                            post={post}
                            initialExpand={initialExpand}
                            show_community={show_community}
                            active_sort={sort && sort === 'active'}
                        />
                    </div>
                    }
                </div>
            )})}
            {loading && Array(25).fill(null).map((_, index) => (
                <Post key={index} initialExpand={initialExpand} show_community={show_community}/>
            ))}
        </div>
    );
}

function Possible3pAd({adConfig, index, feedKey}) {
    const {pro_tier} = useSettings();
    const loggedIn = useLoggedIn();
    const {guest: guestFreq, user: userFreq} = {guest: 25, user: 25};
    const {guest: guestInd, user: userInd} = {guest: 13, user: 13};
    if (!loggedIn &&  (!pro_tier || pro_tier === 0) && ((loggedIn && index >= userInd) || (!loggedIn && index >= guestInd))) {
        const ind = loggedIn ? userInd : guestInd;
        const freq = loggedIn ? userFreq : guestFreq;
        if (index === ind || ((index - ind) % freq === 0)) {
            return <AdUnit feedKey={feedKey} index={index} />
        }
    }
    return false;
}

function Possible1pAd({adConfig, index, feedKey}) {
    const {pro_tier} = useSettings();
    const loggedIn = useLoggedIn();
    const {guest: guestFreq, user: userFreq} = adConfig.v2.feedFrequency;
    const {guest: guestInd, user: userInd} = adConfig.v2.feedStartingIndex;
    if (!loggedIn &&  (!pro_tier || pro_tier === 0) && ((loggedIn && index >= userInd) || (!loggedIn && index >= guestInd))) {
        const ind = loggedIn ? userInd : guestInd;
        const freq = loggedIn ? userFreq : guestFreq;
        if (index === ind || ((index - ind) % freq === 0)) {
            return <AdUnit feedKey={feedKey} index={index} />
        }
    }
    return false;
}

export default styled(PostList)`
  height: 100%;
  width: 100%;
  padding: 4px 0;
  ${Post}:first-of-type {
    padding-top: 10px;
  }
  ${Post}:last-of-type {
    padding-bottom: 10px;
  }
  @media only screen and (max-width: 780px) {
    ${Post} {
      border-bottom: ${({theme}) => theme.color.name === "dark" ? `1px solid ${themecolors.dark_background_5}` : theme.standard_border};
    }
  }
`;
